module.exports = __webpack_public_path__ + "05_mustache_brown.db1db907.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer3/05_mustache_brown.png
// module id = jpmB
// module chunks = 0